<div class="mb-2 p-2 review-element">
    @switch (review().reviewType) {
        @case ('ManagerCommentReview') {
            <manager-comment-review [review]="$any(review())"
                                    [commentAuthors]="commentAuthors()"
                                    [userInfos]="userInfos(review().reviewer.id)"
                                    [userId]="userId()"
                                    (onReviewCommentEdited)="onReviewCommentEdited($event)"
                                    (onReviewCommentDeleted)="onReviewCommentDeleted($event)"></manager-comment-review>
        }
        @case ('PostQuestionReview') {
            <div class="d-flex pt-1">
                <div class="icon-wrapper icon-action">
                    <i class="fa-light" [ngClass]="review().icon"></i>
                </div>
                <div class="">
                    <p class="p-2 pb-1 ps-1 review-text"><span class="name-color">{{reviewer()}}</span> {{review().text(userId(), translateService) | translate}}.</p>
                    <p class="ps-1">
                        <i [matTooltip]="review().date | date: 'medium'" matTooltipPosition="above">{{review().date | time_from_now }}</i>
                        <span class="px-1">•</span> 
                        <button class="review-link" (click)="openItemDialog(review())">{{ 'taskbook.review_history.see_item' | translate }} <i class="fa-regular fa-magnifying-glass ps-1"></i></button>
                    </p>
                </div>
            </div>
        }
        @case ('FinishedQuestionReview') {
            <div class="d-flex pt-1">
                <div class="icon-wrapper icon-action">
                    <i class="fa-light" [ngClass]="review().icon"></i>
                </div>
                <div class="">
                    <p class="p-2 pb-1 ps-1 review-text"><span class="name-color">{{reviewer()}}</span> {{review().text(userId(), translateService) | translate}}.</p>
                    <p class="ps-1">
                        <i [matTooltip]="review().date | date: 'medium'" matTooltipPosition="above">{{review().date | time_from_now }}</i>
                        <span class="px-1">•</span>
                        <button class="review-link" (click)="openItemDialog(review())">{{ 'taskbook.review_history.see_item' | translate }} <i class="fa-regular fa-magnifying-glass ps-1"></i></button>
                    </p>
                </div>
            </div>
        }
        @case ('SendKudosReview') {
            <div class="d-flex pt-1">
                <div class="icon-wrapper icon-action">
                    <i class="fa-light" [ngClass]="review().icon"></i>
                </div>
                <div class="">
                    <p class="p-2 pb-1 ps-1 review-text"><span class="name-color">{{reviewer()}}</span> {{review().text(userId(), translateService) | translate}}.</p>
                    <p class="ps-1">
                        <i [matTooltip]="review().date | date: 'medium'" matTooltipPosition="above">{{review().date | time_from_now }}</i>
                        <span class="px-1">•</span> 
                        <button class="review-link" (click)="openItemDialog(review())">{{ 'taskbook.review_history.see_item' | translate }} <i class="fa-regular fa-magnifying-glass ps-1"></i></button>
                    </p>
                </div>
            </div>
        }
        @case ('CreatedFromOtherItemReview') {
            <div class="d-flex pt-1">
                <div class="icon-wrapper icon-action">
                    <i class="fa-light" [ngClass]="review().icon"></i>
                </div>
                <div class="">
                    <p class="p-2 pb-1 ps-1 review-text"><span class="name-color">{{reviewer()}}</span> {{review().text(userId(), translateService) | translate}}.</p>
                    <p class="ps-1">
                        <i [matTooltip]="review().date | date: 'medium'" matTooltipPosition="above">{{review().date | time_from_now }}</i>
                        <span class="px-1">•</span>
                        <button class="review-link" [routerLink]="linkToOtherItem(review())" >{{ 'taskbook.review_history.see_item' | translate }} <i class="fa-regular fa-magnifying-glass ps-1"></i></button>
                    </p>
                </div>
            </div>
        }
        @default {
            <div class="d-flex pt-1">
                <div class="icon-wrapper" [ngClass]="{'icon-action': review().reviewType === 'AddThreadReview'}">
                    <i class="fa-light" [ngClass]="review().icon"></i>
                </div>
                <div class="">
                    <p class="p-2 pb-1 ps-1 review-text"><span class="name-color">{{reviewer()}}</span> {{review().text(userId(), translateService) | translate}}.</p>
                    <p class="ps-1">
                        <i [matTooltip]="review().date | date: 'medium'" matTooltipPosition="above">{{review().date | time_from_now }}</i>
                    </p>
                </div>
            </div>
        }
    }
</div>